import axios from 'axios';
import { Rollout } from '../interfaces';
import { config } from '../configuration';
import { time } from '../metrics';
import { limitExecution, baseUrl } from './utils';

/**
 * A wrapper around axios's "get" for fetching rollout data from pegasus.
 *
 * @param {string} name The rollout to fetch.
 * @param {number} timeout The fetch timeout. If 0, then no timeout.
 * @returns {Promise<Rollout>}
 */
export const fetchRolloutData = async (name: string, timeout: number): Promise<Rollout> => {
    const start = process.hrtime.bigint();
    const { data }: { data: Rollout } = await limitExecution(
        axios.get(`${baseUrl(config)}/features-core/${name}`),
        timeout
    );

    time(`api.fetch.${name}`, start);

    return data;
};
